import { EventViewData } from 'components/eventView/pages/eventData';

export const DstEvent: EventViewData = {
    eventId: 'dst',
    mapId: '9b216ce5-a30b-405a-9433-c70ee5a170e3',
    guideId: 'd74909b3-763f-4b16-b586-5181abcf78a7',
    filterSettings: {
        map: {
            type: 'simple',
            optionIds: []
        }
    }
};
